module.exports = __webpack_public_path__ + "static/media/Katalog_ROJEK_compressed.6e29d18e.pdf";